import { classNamesFunction, FontIcon, Icon, Persona, PersonaPresence, PersonaSize } from '@fluentui/react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import React from 'react';
import { CoherenceNotificationType } from '../CoherenceNotificationItem.types';
dayjs.extend(duration);
dayjs.extend(localizedFormat);
var getClassNames = classNamesFunction();
export var NotificationIconBase = function (props) {
    var styles = props.styles, theme = props.theme, sender = props.sender, subject = props.subject, notificationType = props.notificationType;
    var classNames = getClassNames(styles, {});
    var getSubjectIcon = function () {
        if (subject === null || subject === void 0 ? void 0 : subject.icon) {
            return React.createElement(Icon, { className: classNames.icon, iconName: subject.icon, style: { color: subject.iconColor } });
        }
        else {
            switch (notificationType) {
                case CoherenceNotificationType.BLOCKED:
                    return (React.createElement(FontIcon, { className: classNames.icon, iconName: 'Blocked2', style: { color: theme === null || theme === void 0 ? void 0 : theme.palette.redDark } }));
                case CoherenceNotificationType.STANDARD:
                    return (React.createElement(FontIcon, { className: classNames.icon, iconName: 'Info', style: { color: theme === null || theme === void 0 ? void 0 : theme.palette.neutralDark } }));
                case CoherenceNotificationType.PENDING:
                    return (React.createElement(FontIcon, { className: classNames.icon, iconName: 'Clock', style: { color: theme === null || theme === void 0 ? void 0 : theme.palette.neutralDark } }));
                case CoherenceNotificationType.SUCCESS:
                    return (React.createElement(FontIcon, { className: classNames.icon, iconName: 'Completed', style: { color: theme === null || theme === void 0 ? void 0 : theme.palette.green } }));
                case CoherenceNotificationType.WARNING:
                    return (React.createElement(FontIcon, { className: classNames.icon, iconName: 'Warning', style: { color: theme === null || theme === void 0 ? void 0 : theme.palette.yellowDark } }));
                case CoherenceNotificationType.ERROR:
                    return (React.createElement(FontIcon, { className: classNames.icon, iconName: 'ErrorBadge', style: { color: theme === null || theme === void 0 ? void 0 : theme.palette.redDark } }));
                case CoherenceNotificationType.NONE:
                default:
                    return null;
            }
        }
    };
    if (sender === null || sender === void 0 ? void 0 : sender.name) {
        return (React.createElement(Persona, { className: classNames.senderImage, imageUrl: sender.imageUrl, presence: PersonaPresence.none, size: PersonaSize.size28, text: sender.name }));
    }
    else {
        return getSubjectIcon();
    }
};
//# sourceMappingURL=NotificationIcon.base.js.map